var map = {
	"./1mdb_lg.jpg": 177,
	"./1mdb_sm.jpg": 178,
	"./2016-results_lg.jpg": 179,
	"./2016-results_sm.jpg": 180,
	"./accredit_lg.jpg": 181,
	"./accredit_sm.jpg": 182,
	"./adspend_lg.jpg": 183,
	"./adspend_sm.jpg": 184,
	"./airports_lg.jpg": 185,
	"./airports_sm.jpg": 186,
	"./apps-by-age_sm.jpg": 187,
	"./asbestos_lg.jpg": 188,
	"./asbestos_sm.jpg": 189,
	"./balance_lg.jpg": 190,
	"./balance_sm.jpg": 191,
	"./bband.gif": 192,
	"./beat-the-fed_lg.jpg": 193,
	"./beat-the-fed_sm.jpg": 194,
	"./billions_lg.jpg": 195,
	"./billions_sm.jpg": 196,
	"./black-panther_sm.jpg": 197,
	"./brexit_lg.jpg": 198,
	"./brexit_sm.jpg": 199,
	"./buchheit_sm.jpg": 200,
	"./burden_lg.jpg": 201,
	"./burden_sm.jpg": 202,
	"./cabinet_lg.jpg": 203,
	"./cabinet_sm.jpg": 204,
	"./calculator_sm.jpg": 205,
	"./cancer-survival_sm.jpg": 206,
	"./carousel_lg.jpg": 207,
	"./carousel_sm.jpg": 208,
	"./cbanks_lg.jpg": 209,
	"./cbanks_sm.jpg": 210,
	"./ceo-pay-15_lg.jpg": 211,
	"./ceo-pay-15_sm.jpg": 212,
	"./ceopay_lg.jpg": 213,
	"./ceopay_sm.jpg": 214,
	"./china_lg.jpg": 215,
	"./china_sm.jpg": 216,
	"./citi_lg.jpg": 217,
	"./citi_sm.jpg": 218,
	"./conclave_lg.jpg": 219,
	"./conclave_sm.jpg": 220,
	"./congress-congrol_sm.jpg": 221,
	"./congress-control_lg.jpg": 222,
	"./congress-control_sm.jpg": 223,
	"./coups_sm.jpg": 224,
	"./dealtrack_lg.jpg": 225,
	"./dealtrack_sm.jpg": 226,
	"./deficit_lg.jpg": 227,
	"./deficit_sm.jpg": 228,
	"./detroit_lg.jpg": 229,
	"./detroit_sm.jpg": 230,
	"./election_map_lg.jpg": 231,
	"./election_map_sm.jpg": 232,
	"./ergonomics_lg.jpg": 233,
	"./ergonomics_sm.jpg": 234,
	"./feddocs_lg.jpg": 235,
	"./feddocs_sm.jpg": 236,
	"./fertility-lines_sm.jpg": 237,
	"./fertility_lg.jpg": 238,
	"./fertility_sm.jpg": 239,
	"./florence-tracker_sm.jpg": 240,
	"./flow-of-goods_sm.jpg": 241,
	"./flu-maps_sm.jpg": 242,
	"./fortune-500_sm.jpg": 243,
	"./g7-leaderrs_sm.jpg": 244,
	"./g7-leaderrs_sm.png": 245,
	"./g7-leaders_sm.jpg": 246,
	"./global-trade_sm.jpg": 247,
	"./grammy-faces_sm.jpg": 248,
	"./ground_zero_lg.jpg": 249,
	"./ground_zero_sm.jpg": 250,
	"./gun-laws_sm.jpg": 251,
	"./gun-moves_sm.jpg": 252,
	"./harris-survey_sm.jpg": 253,
	"./health-care-costs_lg.jpg": 254,
	"./health-care-costs_sm.jpg": 255,
	"./health-care-holdouts_lg.jpg": 256,
	"./health-care-holdouts_sm.jpg": 257,
	"./house-math_sm.jpg": 258,
	"./immigrant-income_sm.jpg": 259,
	"./immigration-districts_sm.jpg": 260,
	"./irmas-evolving-forecast_sm.jpg": 261,
	"./issues_lg.jpg": 262,
	"./issues_sm.jpg": 263,
	"./japan_lg.jpg": 264,
	"./japan_sm.jpg": 265,
	"./jumbo_lg.jpg": 266,
	"./jumbo_sm.jpg": 267,
	"./large-cities_lg.jpg": 268,
	"./large-cities_sm.jpg": 269,
	"./left-behind_lg.jpg": 270,
	"./left-behind_sm.jpg": 271,
	"./lobotomy_lg.jpg": 272,
	"./lobotomy_sm.jpg": 273,
	"./longest-wars_sm.jpg": 274,
	"./manhattan-density_lg.jpg": 275,
	"./manhattan-density_sm.jpg": 276,
	"./manufacturing-jobs_sm.jpg": 277,
	"./marathon_lg.jpg": 278,
	"./marathon_sm.jpg": 279,
	"./mass-shootings_sm.jpg": 280,
	"./mass-shootings_sm.png": 281,
	"./medals_lg.jpg": 282,
	"./medals_sm.jpg": 283,
	"./medicare_lg.jpg": 284,
	"./medicare_sm.jpg": 285,
	"./midterm-results_sm.jpg": 286,
	"./minotaurs_sm.jpg": 287,
	"./mueller-report_sm.jpg": 288,
	"./newswhip_sm.jpg": 289,
	"./newswhip_sm.png": 290,
	"./ng_lg.jpg": 291,
	"./nh_sm.jpg": 292,
	"./north-korea-china_sm.jpg": 293,
	"./open-house-seats_sm.jpg": 294,
	"./oscars_lg.jpg": 295,
	"./oscars_sm.jpg": 296,
	"./outliers_lg.jpg": 297,
	"./outliers_sm.jpg": 298,
	"./pathomap_lg.jpg": 299,
	"./pathomap_sm.jpg": 300,
	"./photo-new.jpg": 301,
	"./players_lg.jpg": 302,
	"./players_sm.jpg": 303,
	"./pr-ships_sm.jpg": 304,
	"./primary_lg.jpg": 305,
	"./primary_sm.jpg": 306,
	"./pyramids_lg.jpg": 307,
	"./pyramids_sm.jpg": 308,
	"./race-and-education_sm.jpg": 309,
	"./race-so-far_lg.jpg": 310,
	"./race-so-far_sm.jpg": 311,
	"./refugee-flows_sm.jpg": 312,
	"./remembering_lg.jpg": 313,
	"./remembering_sm.jpg": 314,
	"./results_lg.jpg": 315,
	"./results_sm.jpg": 316,
	"./rising-seas_sm.jpg": 317,
	"./russia-venn_sm.jpg": 318,
	"./samesex_lg.jpg": 319,
	"./samesex_sm.jpg": 320,
	"./senate-immigration_sm.jpg": 321,
	"./senate-math_sm.jpg": 322,
	"./senateraces_lg.jpg": 323,
	"./senateraces_sm.jpg": 324,
	"./shutdown-states_sm.jpg": 325,
	"./sochi_lg.jpg": 326,
	"./sochi_sm.jpg": 327,
	"./sotu-2018_sm.jpg": 328,
	"./soybeans_sm.jpg": 329,
	"./stamps_lg.jpg": 330,
	"./stamps_sm.jpg": 331,
	"./suburbs-arrows_sm.jpg": 332,
	"./suicides_sm.jpg": 333,
	"./super-tuesday_lg.jpg": 334,
	"./super-tuesday_sm.jpg": 335,
	"./tariffs_sm.jpg": 336,
	"./temperature-anomolies_sm.jpg": 337,
	"./thirty-years-of-atlantic-hurricanes_sm.jpg": 338,
	"./transit_sm.jpg": 339,
	"./treasury-low_lg.jpg": 340,
	"./treasury-low_sm.jpg": 341,
	"./trump-nixon_sm.jpg": 342,
	"./trump-polls_sm.jpg": 343,
	"./uninsured-by-state_sm.jpg": 344,
	"./visas_lg.jpg": 345,
	"./visas_sm.jpg": 346,
	"./wave-scatterplot_sm.jpg": 347,
	"./wcgoals_lg.jpg": 348,
	"./wcgoals_sm.jpg": 349,
	"./wckicks_lg.jpg": 350,
	"./wckicks_lg.png": 351,
	"./wckicks_sm.jpg": 352,
	"./wckicks_sm.png": 353,
	"./wcpasses_lg.jpg": 354,
	"./wcpasses_sm.jpg": 355,
	"./where-they-won_lg.jpg": 356,
	"./where-they-won_sm.jpg": 357,
	"./workwear_lg.jpg": 358,
	"./workwear_sm.jpg": 359,
	"./yield-curve-2019_sm.jpg": 360,
	"./yield-curve_lg.jpg": 361,
	"./yield-curve_sm.jpg": 362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 176;